import { CVSetupProvider } from "./CVSetupJourneyContext";
import CV from './CVStep';
import Journey from "../../Layouts/Journey";

export default Journey({
    journeyTitle: "CV Setup",
    Provider: CVSetupProvider,
    finalRoute: () => `/cvs`
}, CV );